module.exports = __webpack_public_path__ + "static/media/joint.dc48aa59.png";